// extracted by mini-css-extract-plugin
module.exports = {"root":"a8rOR9"};